/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 28/3/2023
 */

import { IconButton, InputBase } from "@mui/material";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

import styles from "./SearchBar.module.css";

const SearchBar = (props) => {
  const { data, setSearchData, text, search, categoriesData } = props;
  const [catIdToNameMapping, setCatIdToNameMapping] = useState({});

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (categoriesData) {
      const mapping = categoriesData.reduce((acc, category) => {
        acc[category.catId] = category.catName;
        return acc;
      }, {});
      setCatIdToNameMapping(mapping);
    }
  }, [categoriesData]);

  const handleChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const sendSearchData = (results) => {
    setSearchData(results);
  };

  useEffect(() => {
    let results;
    switch (search) {
      case "title":
        results = data?.filter(
          (d) =>
            // d.title?.toLowerCase().includes(searchTerm) || d.title?.includes(searchTerm)
            d.itemId
        );
        break;
      case "offer":
        results = data?.filter(
          (d) =>
            d.offerDesc?.toLowerCase().includes(searchTerm) ||
            d.offerDesc?.includes(searchTerm)
        );
        break;
      case "slot":
        results = data?.filter(
          (d) =>
            d.slot?.toLowerCase().includes(searchTerm) ||
            d.slot?.includes(searchTerm)
        );
        break;
      case "resource":
        results = data?.filter(
          (d) =>
            d.name?.toLowerCase().includes(searchTerm) ||
            d.name?.includes(searchTerm)
        );
        break;
      case "user":
        results = data?.filter(
          (d) =>
            d.userName?.toLowerCase().includes(searchTerm) ||
            d.userName?.includes(searchTerm)
        );
        break;
      case "cat":
        results = data?.filter(
          (d) =>
            d.catName?.toLowerCase().includes(searchTerm) ||
            d.catName?.includes(searchTerm)
        );
        break;
      case "suplier":
        results = data?.filter(
          (d) =>
            d.name?.toLowerCase().includes(searchTerm) ||
            d.name?.includes(searchTerm)
        );
        break;
      case "department":
        results = data?.filter(
          (d) =>
            d.departmentName?.toLowerCase().includes(searchTerm) ||
            d.departmentName?.includes(searchTerm)
        );
        break;
      case "resource":
        results = data?.filter(
          (d) =>
            d.resourcesName?.toLowerCase().includes(searchTerm) ||
            d.resourcesName?.includes(searchTerm)
        );
        break;
      case "channel":
        results = data?.filter(
          (d) =>
            d.channelDesc?.toLowerCase().includes(searchTerm) ||
            d.channelDesc?.includes(searchTerm)
        );
        break;
      case "brName":
        results = data?.filter(
          (d) =>
            d.brName?.toLowerCase().includes(searchTerm) ||
            d.brName?.includes(searchTerm)
        );
        break;
      case "privilege":
        results = data?.filter(
          (d) =>
            d.prevName?.toLowerCase().includes(searchTerm) ||
            d.prevName?.includes(searchTerm)
        );
        break;
      case "unitType":
        results = data?.filter(
          (d) =>
            d.unitTypeDesc?.toLowerCase().includes(searchTerm) ||
            d.unitTypeDesc?.includes(searchTerm)
        );
        break;
      case "moqAction":
        results = data?.filter(
          (d) =>
            d.actionDesc?.toLowerCase().includes(searchTerm) ||
            d.actionDesc?.includes(searchTerm)
        );
        break;
      case "DeliveryMthd":
        results = data?.filter(
          (d) =>
            d.trName?.toLowerCase().includes(searchTerm) ||
            d.trName?.includes(searchTerm)
        );
        break;
      case "state":
        results = data?.filter(
          (d) =>
            d.state?.toLowerCase().includes(searchTerm) ||
            d.state?.includes(searchTerm)
        );
        break;
      case "coupon":
        results = data?.filter(
          (d) =>
            d.couponCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.couponCode?.includes(searchTerm)
        );
        break;
      case "area":
        results = data?.filter(
          (d) =>
            d.desc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.desc?.includes(searchTerm)
        );
        break;
      case "freq":
        results = data?.filter(
          (d) =>
            d.freqName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.freqName?.includes(searchTerm)
        );
        break;
      case "res":
        results = data?.filter(
          (d) =>
            d.noRes?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.noRes?.includes(searchTerm)
        );
        break;
      case "request":
        results = data?.filter(
          (d) =>
            d.catName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.catName?.includes(searchTerm)
        );
        break;
      case "price":
        results = data?.filter(
          (d) =>
            d.catName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.catName?.includes(searchTerm)
        );
        break;
      case "charge":
        results = data?.filter(
          (d) =>
            d.chargeDesc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.chargeDesc?.includes(searchTerm)
        );
        break;
      case "hrs":
        results = data?.filter(
          (d) =>
            d.noHrs?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.noHrs?.includes(searchTerm)
        );
        break;
      case "priv":
        results = data?.filter(
          (d) =>
            d.privName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.privName?.includes(searchTerm)
          );
        break;
      case "br":
        results = data?.filter(
          (d) =>
            d.brName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.brName?.includes(searchTerm)
          );
        break;
        case "brPriv":
        results = data?.filter(
          (d) =>
            d.brName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.brName?.includes(searchTerm)
        );
        break;
        case "comment":
          results = data?.filter(
            (d) =>
              d.comment?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              d.comment?.includes(searchTerm)
          );
        break;
        case "review":
          results = data?.filter(
            (d) =>
              d.review?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              d.review?.includes(searchTerm)
          );
        break;
        case "notification":
          results = data?.filter(
            (d) =>
              d.notiName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              d.notiName?.includes(searchTerm)
          );
        break;
      default:
        results = data;
        break;
    }

    if (data?.length !== 0) {
      sendSearchData(results);
    }
  }, [searchTerm, data, setSearchData, search, catIdToNameMapping]);

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.searchBox}>
          <IconButton>
            <SearchIcon className={styles.icon} />
          </IconButton>
        </div>
        <InputBase
          value={searchTerm}
          onChange={handleChange}
          placeholder={text}
          className={styles.searchText}
        />
      </div>
    </div>
  );
};

export default SearchBar;
